import React from 'react';
import { connect } from 'react-redux';
import { map } from 'lodash';
import ReactTable from "react-table";
import cellHeaderHOC from '../../common/Datagrid/CellHeaderHOC';
import Tooltip from "../../common/Tooltip";
import { usersActions } from '../../../data/actions/users';
import { inviteLogSettings } from './InviteLog/Settings'
const CellHeaderTable = cellHeaderHOC(ReactTable);

import Box from '../../common/Box';


class InviteLog extends React.Component {
	constructor(props){
		super(props);
		this.state = {
			defaultSorted: [{ id: "invited_at", desc: true }]
		};
	}
	
	componentDidMount(){
		const { id } = this.props;
		this.props.dispatch(usersActions.getInviteLog(id));
	}
	
	render () {
		const { inviteLog, inviteLogLoading } = this.props.users;
		
		return <Box title="Invitation Log">
			<CellHeaderTable 
				resizable={false}
				loading={inviteLogLoading}
				defaultPageSize={5}
				data={inviteLog} 
				className={"new-releases-track top-tracks-in-playlist simple-table"} 
				columns={inviteLogSettings.settingsForTable()}
				defaultSorted={this.state.defaultSorted}
				noDataText='No invitation history for this user.'
			/>
		</Box>
	}
	
}

function mapStateToProps(state) {
	return {
		users: state.users,
	}
}


export default connect(mapStateToProps)(InviteLog);